import { useState } from 'react';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import addDatasetStorageLocation from 'api/Dataset/addDatasetStorageLocation';
import { useParams } from 'react-router-dom';
import { NewDatasetStorageLocationInput } from 'types/Dataset';

export default function useCreateFolder() {
    const client = useClient();
    const params = useParams();
    const { openAlert } = useAlert();

    const [loading, setLoading] = useState(false);

    const handleSubmit = async (formData: NewDatasetStorageLocationInput) => {
        try {
            if (params.uri) {
                const response = await client.mutate(
                    addDatasetStorageLocation(params.uri, formData),
                );
                if (response.errors) {
                    openAlert({
                        severity: 'alert',
                        message: `Something went wrong...Failed to create folder ${response?.errors[0]?.message}`,
                    });
                }
            }
        } finally {
            setLoading(false);
        }
    };
    return { handleSubmit, loading };
}
